import { ReactNode } from 'react';
import PlaceholderPage from '@/pages/PlaceholderPage';

const DEFAULT_DESCRIPTION =
  'This module is planned for a later phase. Enable the feature flag when you are ready to bring it back into the workspace.';

interface DeferredFeaturePlaceholderProps {
  featureName: string;
  icon: ReactNode;
  description?: string;
}

export default function DeferredFeaturePlaceholder({
  featureName,
  icon,
  description,
}: DeferredFeaturePlaceholderProps) {
  return (
    <PlaceholderPage
      title={`${featureName} is currently disabled`}
      description={description ?? DEFAULT_DESCRIPTION}
      icon={icon}
    />
  );
}
